const repairPartRouter = {
  title: '维修配件',
  type: 'view',
  name: Symbol('repairPart'),
  route: '/repair/part',
  // ⚠️ filePath 必须以 view/ 开头,不能带 ./,否则生产构建抛 "Cannot find module"
  filePath: 'view/order/jz_repairPart.vue',
  inNav: false,
  icon: 'iconfont icon-peijian',
  sortId: 98,
}

export default repairPartRouter
